<template>
  <custom-dialog
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    width="800px"
    class="case-proposal-item-dialog"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <el-form
        label-position="top"
        ref="form"
        :model="form"
        :rules="rules"
      >
        <el-row
          :gutter="20"
          v-if="orderType === 'caseOrder'"
        >
          <el-col :span="12">
            <el-form-item :label="$t('asm_case_proposal_item_dialog.gu_zhang_xiang_mu')">{{form.itemName || '-'}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('asm_case_proposal_item_dialog.gu_zhang_dai_ma')">{{form.eventCode || '-'}}</el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          v-if="orderType === 'caseOrder'"
        >
          <el-col :span="24">
            <el-form-item
              :label="$t('asm_case_proposal_item_dialog.ke_hu_chu_li_fang_an')"
              prop="customerDisposal"
            >
              <custom-editor
                v-model="form.customerDisposal"
                :height="150"
                :readonly="model.type === 'watch'"
                folder="isc/richtext/service"
              ></custom-editor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          v-if="orderType === 'caseOrder'"
        >
          <el-col :span="24">
            <el-form-item :label="$t('asm_case_proposal_item_dialog.ke_hu_chu_li_fu_jian')">
              <t-upload
                accept="image/*,video/*"
                type="file"
                :limit="3"
                :bizId="form.orderProposalId"
                bizType="dms.disposal.customer"
                v-model="form.customerMediaList"
                :disabled="model.type === 'watch'"
                ref="case_proposal_customer_media"
                :autoUpload="false"
              ></t-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label=" orderType === 'caseOrder' ? $t('asm_case_proposal_item_dialog.shclfa') : $t('asm_case_proposal_item_dialog.chu_li_fang_an')"
              prop="serviceDisposal"
            >
              <custom-editor
                v-model="form.serviceDisposal"
                :height="150"
                :readonly="model.type === 'watch'"
                folder="isc/richtext/service"
              ></custom-editor>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label=" orderType === 'caseOrder' ? $t('asm_case_proposal_item_dialog.shclfj') : $t('asm_case_proposal_item_dialog.fang_an')">
              <t-upload
                accept="image/*,video/*"
                type="file"
                :limit="3"
                :bizId="form.orderProposalId"
                bizType="dms.disposal.technician"
                v-model="form.serviceMediaList"
                :disabled="model.type === 'watch'"
                ref="case_proposal_service_media"
                :autoUpload="false"
              ></t-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="closeDialog">{{$t('Common.com_cancel')}}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >{{$t('Common.com_confirm')}}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/**
 * 处理方案（查看，编辑）
 */
import dialogMixins from '@/mixins/dialog_mixins';
import customEditor from '@/components/customEditor';
import tUpload from '@/components/upload.vue';
import apis from '@/utils/apis';

export default {
  name: '',
  mixins: [dialogMixins],
  components: { customEditor, tUpload },
  props: {
    // model: {
    //   // edit, watch
    //   type: '',
    //   data: {
    //     orderProposalId: ''
    // }
    // }
    orderType: [Number, String],
    caseOrderType: [Number, String],
  },
  data() {
    return {
      form: {
        orderProposalId: '',
        // 客户处理方案
        customerDisposal: '',
        customerMediaList: [],
        customerMedia: '',
        // 售后处理方案
        serviceDisposal: '',
        serviceMediaList: [],
        serviceMedia: '',
        itemName: '',
        eventCode: '',
        langCode: '',
        orderDeviceId: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        customerDisposal: [
          {
            type: 'string',
            required: true,
            message: this.$t('Common.com_required')
          },
          {
            max: 500,
            message: this.$t('Common.com_rules_length_max', [500]),
          },
        ],
        serviceDisposal: [
          {
            type: 'string',
            required: true,
            message: this.$t('Common.com_required')
          },
          {
            max: 500,
            message: this.$t('Common.com_rules_length_max', [500]),
          },
        ],
      };
    }, },
  filters: {},
  directives: {},
  methods: {
    getInfo() {
      this.$getJSON(`${apis.caseOrderProposalInfo}/${this.model.data.orderProposalId}`, {}).then((res) => {
        const attachList = res.data.attachList || [];
        const customerMediaList = attachList.filter(item => item.bizType === 'dms.disposal.customer');
        const serviceMediaList = attachList.filter(item => item.bizType === 'dms.disposal.technician');
        this.$setFormatData(this.form, {
          ...res.data,
          customerMediaList,
          serviceMediaList,
        });
      });
    },
    getReqData() {
      return {
        ...this.form,
        attachList: [...this.form.customerMediaList, ...this.form.serviceMediaList],
      };
    },
    update() {
      this.$postJSON(apis.caseOrderProposalUpdate, this.getReqData(), true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
    closeDialog() {
      this.visible = false;
    },
    async onConfirm() {
      if (this.model.type === 'watch') {
        this.closeDialog();
        return;
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const arr = [];
          if (this.$refs.case_proposal_customer_media) {
            arr.push(
              this.$refs.case_proposal_customer_media.submit()
            );
          }
          if (this.$refs.case_proposal_service_media) {
            arr.push(
              this.$refs.case_proposal_service_media.submit()
            );
          }

          await Promise.all(arr);
          this.update();
        }
      });
    },
  },
  created() { },
  mounted() {
    this.getInfo();
  },
};
</script>

<style>
</style>
